import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessageCreatePage } from './message-create';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		MessageCreatePage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(MessageCreatePage),
	],
})
export class MessageCreatePageModule { }



// WEBPACK FOOTER //
// ./src/pages/message-create/message-create.module.ts